import * as type from "../../types/API/settingTypes";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getSettingReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_SETTING:
      return {
        ...state,
        loading: true,
      };
    case type.GET_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData.data,
      };
    case type.GET_SETTING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateSettingReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_SETTING:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData.message,
      };
    case type.UPDATE_SETTING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};